export default {
  SAVE_ORGANISATION_DATA_TO_STORE: 'organisations/SAVE_ORGANISATION_TO_STORE',
  SAVE_ORGANISATIONS_DATA_TO_STORE: 'organisations/SAVE_ORGANISATIONS_DATA_TO_STORE',
};
